import React from 'react'
import MegaMenu from '../components/MegaMenu/MegaMenu'
import Footer from '../components/footer/Footer'
import ServicesPageBanner from '../components/services-page-banner/ServicesPageBanner'
import OurServices from '../components/our-services/OurServices'
import TrustedPartner from '../components/trustedPartners/TrustedPartner'
import NewCaseStudySection from '../components/new-case-study-section/NewCaseStudySection'
import TechStack from '../components/techstack/TechStack'
import NewRoadMap from '../components/new-raodmap-section/NewRoadMap'
import WhyChooseUs from '../components/why-choose-us/WhyChooseUs'
import { Helmet } from 'react-helmet'
import EcommercePlatform from '../components/EcommercePlatform/EcommercePlatform'
import EngagementModelTable from '../components/engagement-models-table/EngagementModelTable'
import { companyCta, ecommercePageFaq, ecommercePageTestimonails, ecommerceTableData, ecommerceTechStacksData, roadmapContent, serviceFeatures, techStackData, trendingInsights, trendInsights, whyUsContent } from '../data/ecommerce-services-page-data'
import CoverTheStack from '../components/coverthestack/CoverTheStack'
import NewTestimonials from '../components/new-testimonials/NewTestimonials'
import FAQ from '../components/Fqas/FAQ'
import SubscriptionPlans from '../components/SubscriptionPlans/SubscriptionPlans'
import SoftwareCompanyCta from '../components/software-company-cta/SoftwareCompanyCta'
import TrendsInsights from '../components/trends-n-insights/TrendsInsights'
import BestPracticeAccordian from '../components/best-practice-accordian/BestPracticeAccordian'
import PorsAndConsCard from '../components/ProsAndConsCards/PorsAndConsCard'

const EcommerceServices = () => {
    return (
        <>
            <Helmet>
                <title>Custom Ecommerce Development Services | Online Ecommerce Stores Developers</title>
                <meta
                    name="description"
                    content="Boost your online sales with Bitsclan’s custom ecommerce development services. We build high-performance ecom websites, mobile apps, and online stores on Shopify, Magento, and more for growth, ROI, and seamless UX."
                />
                <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
                <link rel="canonical" href="https://bitsclan.com/ecommerce-services" />
            </Helmet>
            <MegaMenu />
            <ServicesPageBanner
                shortHeading="Ecommerce Development Services"
                mainHeading="E-Commerce Websites & Strategy That Drive <span>3× ROI 40% Lower Costs</span> & Faster Time-to-Market"
                description="Empowering brands on Shopify Plus, Adobe Commerce, and Magento with scalable digital storefronts, conversion-driven design, and automation that fuels sustainable growth."
            />
            <TrustedPartner heading="Trusted & Partnered by Businesses Worldwide to Build High-Performance E-Commerce Solutions" category={"ecommerce"} />
            <OurServices
                shortHeading="Ecommerce Services We Provide"
                servicesCardsData={serviceFeatures}
                buttonText="Explore Platform Expertise"
                mainHeading="Comprehensive eCommerce Services to Drive Conversions & Sales"
                description="As a trusted eCommerce development company, Bitsclan offers custom eCommerce development services for every business model. We deliver result-driven eCommerce solutions that enhance website performance, elevate customer experience, and generate more conversions."
            />
            <NewTestimonials content={ecommercePageTestimonails} shortHeading="Clients Testimonials" mainHeading="What Our <span>Clients</span> Say About Our Ecommerce Work" description="Our clients praise our eCommerce development expertise, highlighting <a href='/ai-ml-development-services' class='green-internal-link-text' target='_blank'>innovative AI solutions</a>, seamless user experiences, and measurable business growth through our custom digital strategies." />
            <WhyChooseUs
                heading={whyUsContent?.heading}
                greenHeading={whyUsContent?.greenHeading}
                shortHeading={whyUsContent?.shortHeading}
                content={whyUsContent?.content}
                stats={whyUsContent?.stats}
                cta={whyUsContent?.cta}
                sectionImage={whyUsContent?.image}
                imageStats={whyUsContent?.imageStats}

            />
            <NewCaseStudySection shortHeading="Our Ecommerce Development Success Stories" heading="Ecommerce Brnads That Define Real Success Across Industries" description="Bitsclan has a strong history of developing eCommerce solutions that increase sales, improve customer experience, and scale businesses globally for companies and start-ups. We create scalable digital solutions that achieve lasting success through modern design and trusted technology." filter="ecommerce" />
            <CoverTheStack
                whereStart={"CMS & Headless"}
                shortHeading={"Dedicated Technology Stack"}
                mainHeading={"Our Ecommerce Technology Stack"}
                subHeading={"Behind every successful ecommerce store is the right technology stack. We combine proven frameworks, databases, & integrations to deliver secure, high-performing, & scalable solutions."}
                tabs={ecommerceTechStacksData?.tabs}
                tabItems={ecommerceTechStacksData?.tabItems}
            />
            {/* <EcommercePlatform /> */}
            <BestPracticeAccordian />
            <TechStack content={techStackData} />
            {/* <EngagementModelTable content={ecommerceTableData} /> */}
            <PorsAndConsCard />
            <NewRoadMap roadmapContent={roadmapContent} />
            <SubscriptionPlans />

            <TrendsInsights
                category="ai-developmet"
                heading={trendingInsights.heading}
                description={trendingInsights.description}
            />

            <FAQ
                faqs={ecommercePageFaq}
                mainHeading="Frequently Asked Questions"
            />
            <SoftwareCompanyCta content={companyCta} />
            <Footer />
        </>
    )
}

export default EcommerceServices